import services from '@/services/ascentiaServiceIndex'
import { FEATURE_FLAG_CONSTS as FF } from '../consts'

const validateFlag = function (flagToFind, flags) {
  let valOn = false
  if (flags && flagToFind in flags) {
    valOn = flags[flagToFind]
  }
  return valOn
}

const state = {
  featureFlags: {},
}

const getters = {
  aogFaultManagementOn(state) {
    return validateFlag('FaultCodeManagement', state.featureFlags)
  },
  fleetMonitoringOn(state) {
    return validateFlag('FleetMonitoring', state.featureFlags)
  },
}

const mutations = {
  [FF.UPDATE_ALL_FEATURE_FLAGS]: (state, data) => (state.featureFlags = data),
}

const actions = {
  async [FF.GET_ALL_FEATURE_FLAGS]({ commit }) {
    try {
      const response = await services.featureFlag.getData(
        'featureFlags',
        {},
        false,
      )
      const data = response.data
      commit(FF.UPDATE_ALL_FEATURE_FLAGS, data)
    } catch (error) {
      console.log(`${[FF.GET_ALL_FEATURE_FLAGS]}: error ${error}`)
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
